<app-dettaglio-persona (onSaveClick)="saveClick($event)" (onDeleteClick)="deleteClick()" (onCancelClick)="cancelClick()"></app-dettaglio-persona>
<div class="card"  >
  <app-file-uploader (onChange)="onFileChanged()"></app-file-uploader>
</div>


